module.exports = __webpack_public_path__ + "img/vectrex-hero-small.ffdd41ed.png";